/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular expression`)
};

const es_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expresión regular`)
};

const de_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulärer Ausdruck`)
};

const nl_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reguliere uitdrukking`)
};

const fr_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expression régulière`)
};

const it_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espressione regolare`)
};

const pt_br2_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expressão regular`)
};

const pt_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expressão regular`)
};

const ja_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正規表現`)
};

const zh_fr_regex = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正则表达式`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_regex = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_regex(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_regex", locale)
	if (locale === "en") return en_fr_regex(inputs)
	if (locale === "es") return es_fr_regex(inputs)
	if (locale === "de") return de_fr_regex(inputs)
	if (locale === "nl") return nl_fr_regex(inputs)
	if (locale === "fr") return fr_fr_regex(inputs)
	if (locale === "it") return it_fr_regex(inputs)
	if (locale === "pt-BR") return pt_br2_fr_regex(inputs)
	if (locale === "pt") return pt_fr_regex(inputs)
	if (locale === "ja") return ja_fr_regex(inputs)
	return zh_fr_regex(inputs)
};